import { render, staticRenderFns } from "./promo-planner.vue?vue&type=template&id=2f84ed7e&scoped=true"
import script from "./promo-planner.vue?vue&type=script&lang=js"
export * from "./promo-planner.vue?vue&type=script&lang=js"
import style0 from "./promo-planner.vue?vue&type=style&index=0&id=2f84ed7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f84ed7e",
  null
  
)

export default component.exports